import { render } from "./EditRequest2.vue?vue&type=template&id=4d0f6070"
import script from "./EditRequest2.vue?vue&type=script&lang=js"
export * from "./EditRequest2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__